import { Select, createListCollection, Field } from "@chakra-ui/react";
import { prefectures } from "@/lib/utils";

const prefectureOptions = createListCollection({
  items: Object.entries(prefectures).map(([value, label]) => ({ label, value })),
});

interface PrefectureSelectProps {
  value: string;
  onChange: (value: string) => void;
}

export default function PrefectureSelect({ value, onChange }: PrefectureSelectProps) {
  return (
    <Field.Root>
      <Field.Label fontWeight="semibold" fontSize="sm">
        都道府県
      </Field.Label>
      <Select.Root
        collection={prefectureOptions}
        value={value ? [value] : []}
        onValueChange={v => onChange(v.value[0] || "")}
        size="lg"
      >
        <Select.Control>
          <Select.Trigger
            borderRadius="lg"
            bg="gray.50"
            _focus={{ bg: "white", borderColor: "blue.400", shadow: "0 0 0 1px var(--chakra-colors-blue-400)" }}
          >
            <Select.ValueText placeholder="都道府県を選択" />
          </Select.Trigger>
          <Select.IndicatorGroup>
            <Select.Indicator />
            <Select.ClearTrigger />
          </Select.IndicatorGroup>
        </Select.Control>

        <Select.Positioner>
          <Select.Content borderRadius="lg" shadow="xl" maxH="300px" overflowY="auto">
            {prefectureOptions.items.map(option => (
              <Select.Item item={option} key={option.value}>
                {option.label}
                <Select.ItemIndicator />
              </Select.Item>
            ))}
          </Select.Content>
        </Select.Positioner>
      </Select.Root>
    </Field.Root>
  );
}
